<template>
  <div>
    <div class="inline-block pr-4 pb-4 w-1/2">
      <p
        class="align-top font-semibold font-sans leading-snug subpixel-antialiased text-base text-black"
      >
        {{ label }}
      </p>
    </div>
    <div class="inline-block pb-4 w-1/2">
      <p
        v-if="formattedValue"
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base text-black"
      >
        {{ formattedValue }}
      </p>
      <p
        v-else
        class="align-top font-light font-sans leading-none subpixel-antialiased text-base"
      >
        Not provided
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoeCellDropdown",
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String
    },
    value: {
      type: String
    },
    options: {
      // this must be array of objects
      // with each object having atleast 2 props - text and value
      // eg - [ { text: "Female", value: "F" } ]
      type: Array,
      validator: prop =>
        prop.every(e => typeof e === "object" && e["text"] && e["value"])
    }
  },
  computed: {
    formattedValue() {
      const foundOption = this.options.find(opt => opt.value === this.value);
      return foundOption ? foundOption.text : null;
    }
  }
};
</script>

<style lang="scss" scoped></style>
